module.exports = __webpack_public_path__ + "img/雅居乐.02ae632d.png";